import type { Node } from '../../types';

export type SemanticRulesExtractionNodeType = Node<{ test: string }>;

/**
 * 语义规则节点 jobData
 */
export interface SemanticRulesExtractionNodeJobData {
  /**
   * 抽取范围
   */
  extraction_range: keyof typeof ExtractionRangeEnum;
  /**
   * 忽略页眉页脚
   */
  ignore_headers: boolean;
  pages: string;
  rules: SemanticRule[];
}

/**
 * 抽取范围
 */
export const ExtractionRangeEnum = {
  ALL: 'ALL',
  FIRST: 'FIRST',
  LAST: 'LAST',
  TARGET: 'TARGET',
} as const;

/**
 * SemanticRule
 */
interface SemanticRule {
  /**
   * 抽取点
   */
  tag_code: string;
  /**
   * 抽取规则
   */
  tag_rule_configs: TagRuleConfig[];
}

/**
 * TagRuleConfig
 */
interface TagRuleConfig {
  contain: TextConfig;
  greedy: boolean;
  max_len: number;
  min_len: number;
  not_contain: TextConfig;
  post_text: TextConfig;
  pre_text: TextConfig;
  prefix: TextConfig;
  regex_expression: string;
  rule_name: string;
  suffix: TextConfig;
  tag_code: string;
  type: string;
}

/**
 * TextConfig
 */
interface TextConfig {
  type: string;
  values: string[];
}
